import { Component } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ToolbarEventManagerHelper } from './../../../services/event-managers/toolbar-event-manager.helper';

@Component({
  selector: 'app-delete-item-button',
  standalone: false,
  templateUrl: './delete-item-button.component.html',
  styleUrl: './delete-item-button.component.scss',
})
export class DeleteItemButtonComponent extends BaseComponent {
  constructor(private toolbarEventManagerHelper: ToolbarEventManagerHelper) {
    super();
  }

  public onDeleteClick(event: Event): void {
    if (event) {
      event.stopPropagation();
    }
    // Trigger delete event through toolbar event manager
    this.toolbarEventManagerHelper.DoDeleteItemTrigger = true;
  }
}
